module.exports = __webpack_public_path__ + "static/media/uz.519585c3.svg";